import { Component, HostListener, OnDestroy, OnInit } from "@angular/core";
import { FormControl, FormGroup, ValidationErrors, Validators } from "@angular/forms";
import { Store } from "@ngrx/store";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { Observable, Subscription, filter } from "rxjs";
import { AppState } from "src/app/store/app.reducer";
import { StandardNewValidator, StandardPageLayout } from "src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib";
import * as DeviceBoardusersActions from 'src/app/store/device-boardusers/device-boardusers.actions';
import { selectBoardUsersExported, selectBoardUsersExporting, selectBoardUsersUpdated, selectBoardUsersUpdating, selectBoardUsersVersionLists } from "src/app/store/device-boardusers/device-boardusers.selector";
import { BoardUsersList } from "src/app/model/board-user";
import { BOARD_USERS_LISTS_DEFAULT_SORT_COLUMN, BOARD_USERS_LISTS_DEFAULT_SORT_COLUMN_DIRECTION, BOARD_USERS_LISTS_PAGE_DEFAULT_SIZE } from "src/app/conf/board-users";
import { PaginationParams } from "src/app/model/api/pagination-params";

@Component({
	templateUrl: './board-users-export-list.dialog.component.html',
})

export class BoardUsersExportListDialogComponent implements OnInit, OnDestroy {
	addboarduserListForm: FormGroup;

	listUpdating: boolean = false; // default: exporting, not edit (updating)

	updated$: Observable<boolean | undefined>;
	updatedSub: Subscription;

	updating: boolean;
	updating$: Observable<boolean | undefined>;
	updatingSub: Subscription;

	exporting: boolean;
	exporting$: Observable<boolean | undefined>;
	exportingSub: Subscription;
	exported$: Observable<boolean | undefined>;
	exportedSub: Subscription;

	boardUserList: BoardUsersList = new BoardUsersList();

	listId: number;
	pagedVersionLists: string = '';
	versionLists: string = '';
	versionLists$: Observable<string | undefined>;
	versionListsSub: Subscription;

	paging: PaginationParams = {
		size: BOARD_USERS_LISTS_PAGE_DEFAULT_SIZE,
		page: 1,
		sort: BOARD_USERS_LISTS_DEFAULT_SORT_COLUMN,
		order: BOARD_USERS_LISTS_DEFAULT_SORT_COLUMN_DIRECTION,
	};

	// design
	screenWidth: number;

	constructor(
		private store: Store<AppState>,
		private ref: DynamicDialogRef,
		public config: DynamicDialogConfig
	) {
		if (config.data !== undefined && config.data.boardUserList !== undefined &&
			(config.data.listUpdating !== undefined && config.data.listUpdating === true)) { // edit with valid config.data
			this.boardUserList = config.data.boardUserList;
			this.listId = config.data.boardUserList.Id;
			this.listUpdating = config.data.listUpdating; // edit -> true
			if (config.data.paging) {
				this.paging = config.data.paging;
			}
		}
		if (config.data !== undefined && config.data.versionLists !== undefined) { // passed by export and edit father components
			this.pagedVersionLists = config.data.versionLists
		}

		this.initSelectors();
	}

	ngOnInit(): void {
		this.subscribeAll();
		this.buildForm();
		this.onResize();

		// this.getBoardusersListsDefault(); // trigger for have updated versionList (doesn't have a sense this paginated call)

		StandardNewValidator.setFirstCompile(true);
	}

	initSelectors(): void {
		this.updating$ = this.store.select(selectBoardUsersUpdating);
		this.updated$ = this.store.select(selectBoardUsersUpdated);
		this.exporting$ = this.store.select(selectBoardUsersExporting);
		this.exported$ = this.store.select(selectBoardUsersExported);
		this.versionLists$ = this.store.select(selectBoardUsersVersionLists);
	}

	buildForm(): void {
		this.addboarduserListForm = new FormGroup({
			'name': new FormControl(this.boardUserList.Name, [Validators.required, Validators.minLength(5)]),
		});
	}

	subscribeAll(): void {
		this.updatingSub = this.updating$?.subscribe(
			(updating) => {
				this.updating = updating;
			}
		);
		this.updatedSub = this.updated$?.subscribe(
			(res) => {
				if (res) {
					this.closeDialog();
				}
			}
		);
		this.exportingSub = this.exporting$?.subscribe(
			(exporting) => {
				this.exporting = exporting;
			}
		);
		this.exportedSub = this.exported$?.pipe(filter(res => !!res)).subscribe(
			() => {
				// this.getBoardusersListsDefault();
				this.closeDialog();
			}
		);
		this.versionListsSub = this.versionLists$.subscribe(versionLists => {
			this.versionLists = versionLists;
		});
	}

	ngOnDestroy(): void {
		this.updatingSub?.unsubscribe();
		this.updatedSub?.unsubscribe();
		this.exportingSub.unsubscribe();
		this.exportedSub?.unsubscribe();
		this.versionListsSub?.unsubscribe();
	}

	get f(): any {
		return this.addboarduserListForm.controls;
	}

	// getBoardusersListsDefault() {
	// 	this.store.dispatch(DeviceBoardusersActions.getBoardusersLists({
	// 		paging: {
	// 			size: BOARD_USERS_LISTS_PAGE_DEFAULT_SIZE,
	// 			page: 1,
	// 			sort: BOARD_USERS_LISTS_DEFAULT_SORT_COLUMN,
	// 			order: BOARD_USERS_LISTS_DEFAULT_SORT_COLUMN_DIRECTION,
	// 		}
	// 	}));
	// }

	// could be an advice for user
	// mismatchVersionsLists(): boolean {
	// 	if (this.versionLists === '' || this.pagedVersionLists === '') { // we didn't have loaded right values so we advice reload page
	// 		return true;
	// 	}
	// 	return this.versionLists !== this.pagedVersionLists;
	// }

	getFormValidationErrors(): boolean {
		let atLeastOneError = false;
		Object.keys(this.addboarduserListForm.controls).forEach(key => {
			const controlErrors: ValidationErrors = this.addboarduserListForm.get(key).errors;
			if (controlErrors != null) {
				/* Object.keys(controlErrors).forEach(keyError => {
					console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
				}); */
				atLeastOneError = true;
			}
		});
		return atLeastOneError;
	}

	submit(): void {
		StandardNewValidator.setFirstCompile(false);
		if (!this.getFormValidationErrors()) {
			this.save();
		}
	}

	save(): void {
		if (this.listUpdating) { // renaming existing list
			this.store.dispatch(DeviceBoardusersActions.editBoarduserList({
				name: this.addboarduserListForm.value.name,
				version: this.versionLists,
				listId: this.listId,
				paging: this.paging,
			}));
		} else { // export new list
			this.store.dispatch(DeviceBoardusersActions.exportBoarduserList({
				name: this.addboarduserListForm.value.name,
				version: this.versionLists
			}));
		}
	}

	closeDialog(): void {
		this.ref.close();
	}

	@HostListener('window:resize')
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	dynamicButtonWidth(): string {
		return StandardPageLayout.dynamicButtonWidth(this.screenWidth);
	}

	dynamicInputTextWidth(): string {
		return StandardPageLayout.dynamicInputTextWidth(this.screenWidth, 'w-30rem');
	}

	justifyContentStyle(): string {
		return StandardNewValidator.justifyMessagesNewValidator(this.screenWidth);
	}

	newShowErrors(type: BoardUsersExportListDialogComponent['f'], classType: string): string {
		return StandardNewValidator.newShowErrors(type, classType, this.screenWidth);
	}

	showErrorRequiredMessage(type: BoardUsersExportListDialogComponent['f']): boolean {
		return StandardNewValidator.showErrorRequiredMessage(type);
	}

	customPaddingX(): string {
		return StandardPageLayout.customPaddingX(this.screenWidth);
	}
}
